import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/book-open.vue
var o = {
	name: "DtIconBookOpen",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--book-open"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Book Open",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		d: "m5.5 11.25-.005-.099a1 1 0 0 0-.995-.901H1a.5.5 0 0 1-.5-.5v-7.5a.5.5 0 0 1 .5-.5h3l.247.013a2.5 2.5 0 0 1 1.52.72c.086.084.162.177.233.272.071-.095.147-.188.232-.273A2.5 2.5 0 0 1 8 1.75h3l.1.01a.5.5 0 0 1 .4.49v7.5a.5.5 0 0 1-.5.5H7.5a1 1 0 0 0-1 1l-.01.1a.5.5 0 0 1-.98 0l-.01-.1Zm-4-2h3c.354 0 .698.095 1 .27V4.25l-.008-.148a1.5 1.5 0 0 0-1.344-1.344L4 2.75H1.5v6.5Zm5 .27c.302-.175.646-.27 1-.27h3v-6.5H8a1.5 1.5 0 0 0-1.5 1.5v5.27Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=book-open.js.map